<template>
  <div>
    <SignCreateLegalAccount v-if="!showSignsList" />
    <SignList :members="members" v-else />
  </div>
</template>
<script>
import legalService from "@/services/modules/legalService";
import SignCreateLegalAccount from "@/components/LegalEntitySignsList/SignCreateLegalAccount.vue";
import SignList from "@/components/LegalEntitySignsList/SignList.vue";
export default {
  components: { SignCreateLegalAccount, SignList },
  data() {
    return {
      showSignsList: false,
      members: [],
      CA_ID: this.$route.query.CA_ID
    };
  },
  mounted() {
    legalService.accountDetailsWithMember(this.CA_ID).then(res => {
      const data = res.data.data;
      this.showSignsList = data.is_current_user_accepted;
      this.members = data.members;
    });
  }
};
</script>
